/**
 * Progressive disclosure for the destination ranking list.
 *
 * The page scores and ranks *every* destination (~250) cheaply in memory, but
 * server-rendering every card with its full week heatmap produced a 5-10 MB
 * HTML payload and hundreds of cards to hydrate — the real cause of the slow
 * load (TTFB stays ~0.2-0.3s; the cost is render + transfer + hydration). We
 * therefore paint only the top slice and reveal the rest on demand. Ranking
 * still runs over the whole set, so the top N are always the genuine top N.
 */

export const INITIAL_VISIBLE = 3;
export const LOAD_MORE_STEP = 5;

export type PaginationView = {
  /** How many cards to render. */
  shown: number;
  /** Whether to show the "Load more" button. */
  hasMore: boolean;
  /** How many ranked destinations are still hidden. */
  remaining: number;
};

export function paginate(total: number, visibleCount: number): PaginationView {
  const shown = Math.min(Math.max(visibleCount, 0), total);
  return {
    shown,
    hasMore: shown < total,
    remaining: Math.max(0, total - shown),
  };
}

export function nextVisible(current: number): number {
  return current + LOAD_MORE_STEP;
}
